<template>
  <v-menu
    content-class="ag-menu"
    open-delay="100"
    :close-delay="closeDelay"
    :persistent="!closeOnClick"
    :close-on-content-click="closeOnContentClick"
    :max-width="maxWidth"
    :width="minWidth"
    :offset="offset"
    :open-on-click="openOnClick"
    :open-on-focus="openOnFocus"
    :open-on-hover="openOnHover"
  >
    <template #activator="{ props }">
      <span v-bind="props">
        <slot name="menu-activator" />
      </span>
    </template>

    <template #default>
      <v-list>
        <slot name="menu-items" />
      </v-list>
    </template>
  </v-menu>
</template>

<script>
export default {
  props: {
    minWidth: {
      type: [Number, String],
      default: 'auto',
    },

    maxWidth: {
      type: [Number, String],
      default: 'auto',
    },

    offset: {
      type: Number,
      default: 8,
    },

    openOnHover: {
      type: Boolean,
      default: false,
    },

    openOnFocus: {
      type: Boolean,
      default: false,
    },

    openOnClick: {
      type: Boolean,
      default: true,
    },

    closeOnClick: {
      type: Boolean,
      default: true,
    },

    closeOnContentClick: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    closeDelay() {
      return this.openOnHover ? 100 : 0;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(.ag-menu) {
  .v-list {
    padding: 0;
    box-shadow: 0 4px 4px 0 #00000040 !important;
  }

  .v-list-group__items {
    .v-list {
      box-shadow: none !important;
    }
  }
}
</style>
